import React, { useState } from "react";
import { Button, Form, Upload, message } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import { ImportGroup } from "../../../api/admin";

const { Dragger } = Upload;

export default function GroupExcelForm() {
	const [fileList, setFileList] = useState([]);

	const uploadProps = {
		multiple: false,
		beforeUpload: (file) => {
			setFileList([file]);   // 1개만
			return false;          // 자동 업로드 막고, submit에서 업로드
		},
		onRemove: () => setFileList([]),
		fileList,
	};

	return (
		<Form
			layout="vertical"
			onFinish={async (values) => {
				if (!fileList.length) {
					message.error("엑셀 파일을 선택해주세요.");
					return;
				}
				try {
					const data = await ImportGroup({
						file: fileList[0],
					});
					if (data.data.ok) {
						message.success(`${data.data.message} (${data.data.result?.group_name} - ${data.data.result?.count}명)`);
						setFileList([]);
					} else {
						message.error(data.data.message || "실패", 5);
						setFileList([]);
					}
				} catch (e) {
					message.error(e?.response?.data?.message || "업로드 실패", 5);
					setFileList([]);
				}
			}}
		>
			<div style={{ 
				marginBottom: 16, 
				padding: 10, 
				background: '#f6f8fa', 
				borderRadius: 8,
				border: '1px solid #d0d7de'
			}}>
				<div style={{ marginBottom: 8 }}>
					<strong>📋 일괄 등록 시 데이터 양식 규칙</strong>
				</div>
				<div style={{ color: '#666', fontSize: 14 }}>
					- 엑셀 시트명은 수정하지 않고 그대로
				</div>
				<div style={{ color: '#666', fontSize: 14 }}>
					- 주소는 반드시 도로명 주소( 
					<a href="https://www.juso.go.kr/" target="_blank_">도로명주소 서비스 </a>
					참고) 주소가 잘못 되면 통계자료에서 지역데이터가 제대로 집계되지 않음.
				</div>
				<div style={{ color: '#666', fontSize: 14 }}>
					- 생년월일은 반드시 ####-##-## (e.g. 1900-01-01) 형태
				</div>
				<div style={{ color: '#666', fontSize: 14 }}>
					- 휴대폰번호는 010-####-#### (e.g. 010-1234-1234) 형태
				</div>
				<div style={{ color: '#666', fontSize: 14}}>
					- 성별은 남성 또는 여성
				</div>
				<div style={{ color: '#666', fontSize: 14, marginBottom: 12  }}>
					- 종목은 10.19km코스 / 5km코스 (km는 반드시 소문자, 띄어쓰기 X)
				</div>
				{/* <a 
					href={`${API}/static/xlsx/group_template.xlsx`}
					download="단체참가신청양식.xlsx"
				>
					<Button 
						icon={<DownloadOutlined />}
						type="dashed"
						size="small"
					>
						단체참가신청양식 파일 다운로드
					</Button>
				</a> */}
			</div>
			<Form.Item label="엑셀 파일(XLSX FILE) - 파일 1개씩 등록">
				<Dragger {...uploadProps} accept=".xlsx" style={{ padding: '10px 20px' }}>
					<p className="ant-upload-text">Click or drag xlsx file</p>
				</Dragger>
			</Form.Item>

			<Button type="primary" htmlType="submit">
				일괄등록 실행
			</Button>
		</Form>
	);
}
